<div class="row margin-row" *ngIf="accessPermission.canAccess(accessPermission.taskList.access.mda)">
    <p-fieldset legend="TT MDA Self Service Tool">
      <div class="card-arrangement">
        <div class="card-details"  *ngIf="accessPermission.canAccess(accessPermission.taskList.access.sst)">
          <a href="/sst" class="no-decoration">
            <p-card>
              <p-avatar
                icon="bi bi-person-fill icon-size"
                styleClass="me-2"
                size="large"
                shape="circle"
              />
              <b>TT Single User Management</b>
            </p-card>
          </a>
        </div>
        <div class="card-details"  *ngIf="accessPermission.canAccess(accessPermission.taskList.access.bulkUpload)">
          <a href="/bulkupload" class="no-decoration">
            <p-card>
              <p-avatar
                icon="bi bi-people-fill icon-size"
                styleClass="me-2"
                size="large"
                shape="circle"
              />
              <b>TT Bulk User Management</b>
            </p-card>
          </a>
        </div>
        <div class="card-details" *ngIf="accessPermission.canAccess(accessPermission.taskList.access.mdr)">
          <a href="/reports" class="no-decoration">
            <p-card>
              <p-avatar
                icon="bi bi-file-earmark-excel-fill icon-size"
                styleClass="me-2"
                size="large"
                shape="circle"
              />
              <b>TT Configuration Reports</b>
            </p-card>
          </a>
        </div>
      </div>
    </p-fieldset>
</div>

<div class="row margin-row"  *ngIf="accessPermission.canAccess(accessPermission.taskList.access.open)">
  <p-fieldset legend="Monthly Closing Process">
    <div class="card-arrangement">
      <div class="card-details" *ngIf="accessPermission.canAccess(accessPermission.taskList.access.xpwd)">
        <a href="/xpwd" class="no-decoration">
          <p-card>
            <p-avatar
              icon="bi bi-file-earmark-spreadsheet-fill icon-size"
              styleClass="me-2"
              size="large"
              shape="circle"
            />
            <b>Cross Project Work Dispatcher</b>
          </p-card>
        </a>
      </div>
      <div class="card-details" *ngIf="accessPermission.canAccess(accessPermission.taskList.access.open)">
        <a href="/closingdate" class="no-decoration">
          <p-card>
            <p-avatar
              icon="bi bi-calendar2-event-fill icon-size"
              styleClass="me-2"
              size="large"
              shape="circle"
            />
            <b>Closing Dates and Rules</b>
          </p-card>
        </a>
      </div>
    </div>
  </p-fieldset>
</div>